export class DashboardGraphLayout {
    'x';
    'y';
    'w';
    'h';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "x",
            "baseName": "x",
            "type": "number",
            "format": ""
        },
        {
            "name": "y",
            "baseName": "y",
            "type": "number",
            "format": ""
        },
        {
            "name": "w",
            "baseName": "w",
            "type": "number",
            "format": ""
        },
        {
            "name": "h",
            "baseName": "h",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DashboardGraphLayout.attributeTypeMap;
    }
    constructor() {
    }
}
